import React, { memo } from "react";
import classes from "./PreviewSkeleton.scss";
import { getPaperHeightAndWidth } from "@toddle-edu/transcript-viewer/Utils";
import { PAGE_SIZE } from "@toddle-edu/transcript-viewer/Constants";
import Preview from "TranscriptsV3/components/Preview";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import { useTranslation } from "react-i18next";

const PreviewSkeleton = () => {
  const { t } = useTranslation(["common", "transcript"]);
  const { width, height } = getPaperHeightAndWidth({
    pageSize: PAGE_SIZE.A4,
    isLandscape: false,
  });

  return (
    <section
      className={classes.container}
      aria-label={t("common:preview_with_label", {
        label: t("transcript:transcript"),
      })}
      aria-busy="true"
    >
      <Preview width={width} height={height} fitToWidth maxWidth={width}>
        <SkeletonLoader height={height} width={width} />
      </Preview>
    </section>
  );
};

export default memo(PreviewSkeleton);
